module.exports = {
  // Families
  defaultFontFamily: 'Roboto, "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  monoSpaceFontFamily: '"Ubuntu Mono", Menlo, Monaco, Consolas, "Courier New", monospace;',
  passwordFamily: 'text-security-disc',

  // Sizes
  extraSmallFontSize: '11px',
  smallFontSize: '12px',
  defaultFontSize: '14px',
  intermediateFontSize: '15px',
  largeFontSize: '16px',

  lineHeight: '1.528571429'
};
